import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=19b6261a&scoped=true&"
import script from "./FaqItem.vue?vue&type=script&lang=js&"
export * from "./FaqItem.vue?vue&type=script&lang=js&"
import style0 from "./FaqItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FaqItem.vue?vue&type=style&index=1&id=19b6261a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6261a",
  null
  
)

export default component.exports